module.exports = __webpack_public_path__ + "img/dynamicLogo2.1a191abe.png";